import { ReactElement } from 'react';
import { FormikContextType } from 'formik';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useEffect } from 'react';
import withComponentLoader from '../../../../hoc/withComponentLoader';
import AppWrappedInput from './AppWrappedInput';

/**
 * Radio Button Set input base component stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {Function} props.setLoading setter function coming from `withComponentLoader` HOC
 * @param {string} props.label display text
 * @param {FormikContextType} props.formik full Formik Context
 * @param {string|ReactElement} props.helperText helper text
 * @param {string[]|object[]} props.options list of options to display.  Should be list of strings or a list of objects with the shape {key: string, disabled: bool}.
 * @param {boolean} props.isRequired flag to determine whether to show required indicator
 * @param {boolean} props.isLoading flag to indicate the loading state (comes from parent)
 * @param {boolean} props.isDisabled flag to indicate if input is interactive
 * @param {object} props.props the rest of the props
 * @returns Radio Button Set input stylized for custom
 */
const AppWrappedRadios = ({
	setLoading,
	label,
	formik,
	helperText,
	options = [],
	isRequired = false,
	isLoading = false,
	isDisabled = false,
	...props
}) => {
	useEffect(() => {
		setLoading(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	return (
		<AppWrappedInput
			label={label}
			error={
				formik.touched[props.name] ? formik.errors[props.name] : null
			}
			isRequired={isRequired}
		>
			<FormControl variant='filled' fullWidth>
				<FormHelperText>{helperText}</FormHelperText>
				<RadioGroup
					aria-labelledby={'radio-group--' + props.name}
					name={props.name}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					value={formik.values[props.name]}
				>
					{options.map(o =>
						typeof o === 'object' ? (
							<FormControlLabel
								key={o.key}
								value={o.key}
								control={<Radio />}
								label={o.label ?? o.key}
								disabled={isDisabled || o.isDisabled}
							/>
						) : (
							<FormControlLabel
								key={o}
								value={o}
								control={<Radio />}
								label={o}
								disabled={isDisabled}
							/>
						)
					)}
				</RadioGroup>
			</FormControl>
		</AppWrappedInput>
	);
};
export default withComponentLoader(AppWrappedRadios);
